module.exports = __webpack_public_path__ + "media/brand/bubbles-cdcda34d.svg";